import { Div } from "../../../../../components/div/Div"
import { theme } from "../../../../../styles/stitches.config"

export function ProgressBar({ stepsNum, sections }: { stepsNum: number; sections: ReadonlyArray<string> }) {
  return (
    <Div css={{ paddingBottom: theme.space.s4 }}>
      <Div
        css={{
          maxWidth: "624px",
          height: theme.sizes.s2,
          margin: "0 auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: theme.space.s1,
        }}
      >
        {sections.map((_, index) => (
          <Div
            key={index}
            css={{
              flexGrow: 1,
              height: theme.sizes.s2,
              background: index < stepsNum ? theme.colors.secondary : theme.colors.lines,
            }}
          />
        ))}
      </Div>
    </Div>
  )
}
